<ion-nav #caseForm [ngClass]="{'centered':isViewCentered, 'presentationMode': isFullscreen}"></ion-nav>